import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import StagesManager from "../components/StagesManager";
import Cookies from "universal-cookie";
import { checkDefaultTab, chooseFontColor } from "../utils/useful";
import { DeskFrames } from "../variables/AppletPages";
import BaseAdminView from "./Applets/BaseAdminView";
import Header from "../components/header/Header";
import DeskSelectApplet from "./Desk/DeskSelectApplet";
import HttpServices from "../utils/Http.services";
import PageViewer from "./PageViewer";
import CollectionView from "./Applets/database/CollectionView";

class DeskApplet extends Component {

    state = {
        headerConfig: {
            showToolbar: false, showSettings: false, showSettings: false, showFrames: 'desk', type: 'desk', isPortal: true, title: '{{lang}}Desk', frames: []
        },
        colors: {
            primaryColor: '#184D94',
            secondaryColor: '#246AC7',
            textColor: '#fff'
        },
        frames: [],
        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: false },
            { key: 'parent', type: 'SelectInput', information: { label: '{{lang}}parent', address: 'getMyTasks', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false, disabled: true }, showMain: false },
            { key: 'timeline.dueDate', type: 'DateInput', col: '12', information: { label: '{{lang}}desk.Due Date', inplaceEditable: false, placeholder: '{{lang}}desk.Date', required: false }, showMain: true },
            { key: 'categorizer', type: 'CategorizerInput', fullCol: true, information: { label: '{{lang}}Categorizer', inplaceEditable: false, required: false, type: 'api', address: 'getInputOptions', fields: { title: 'label', value: '_id', parent: 'parent', colors: 'colors' }, filter: { applet: '{{appletId}}', frame: '{{frameId}}', appletHub: '{{appletHub}}' }, }, showMain: true, inExport: true },
            { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}desk.priority', inplaceEditable: false, placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#fff', bgColor: '#CA5C72' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#fff', bgColor: '#f5b00f' }, { label: '{{lang}}desk.Low', key: 'low', color: '#fff', bgColor: '#20c676' }], required: false } },
            { key: 'assignee', type: 'GlobalUserInput', information: { label: '{{lang}}Assignee', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
            { key: 'collaborators', type: 'GlobalUserMultiInput', information: { label: '{{lang}}Collaborators', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
        ],
        mainFrames: [],
        list: [],
        page: {}
    }

    componentDidMount() {
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
            return
        }
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ pageStatus: 200 }, () => {
                this.init()
                this.checkDefaultTab()
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401, hasToken: false })
                }
            }, 500)
        }
    }
    init = () => {
        let headerConfig = this.state.headerConfig
        headerConfig.frames = this.state.frames

        let data = {}
        data.mode = 'Tportal'
        data.features = 'Tasking'
        // this.setState({ isLoadingList: true })

        HttpServices.request('getPortalFrame', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            console.log('oooooll', this.props.defaultHeaderConfig)
            this.setHeader(headerConfig)
            let mainPage = fetchResult.info
            mainPage.key = mainPage._id
            mainPage.section = 'pages'
            mainPage.pageType = 'page'
            this.setState({ mainPage, frames: fetchResult.frames, applets: fetchResult.applets })
        })

    }
    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }
    componentDidUpdate(prevProps) {
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
        // if (this.state.frames && JSON.stringify(this.state.frames) != JSON.stringify(prevProps.frames)) {
        //     let frames = []
        //     if (Array.isArray(this.state.frames)) {
        //         this.state.frames.forEach(mframe => {
        //             let element = mframe
        //             if (element) {
        //                 if (mframe?.type == 'page') {
        //                     element.key = element._id
        //                     element.section = 'pages'
        //                     element.pageType = 'page'
        //                     element.fetchUrl = 'getRecords'
        //                     element.addUrl = 'postRecord'
        //                     element.editUrl = 'postRecord'
        //                     element.removeUrl = 'removeRecord'
        //                     element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
        //                     element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
        //                     element.fields = this.state.headers
        //                     frames.push(element)
        //                 }
        //                 else if (mframe?.type == 'recordClassifier') {
        //                     element.key = element._id
        //                     element.section = 'pages'
        //                     element.pageType = 'classifier'
        //                     element.fetchUrl = 'getMyTasks'
        //                     element.addUrl = 'postRecord'
        //                     element.editUrl = 'postRecord'
        //                     element.removeUrl = 'removeRecord'
        //                     element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
        //                     element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
        //                     element.fields.forEach(field => {
        //                         field.key = field.key
        //                     });
        //                     frames.push(element)
        //                 }
        //                 else {
        //                     element.key = element._id
        //                     element.section = 'collections'
        //                     element.pageType = 'collection'
        //                     element.fetchUrl = 'getMyTasks'
        //                     element.addUrl = 'addTask'
        //                     element.editUrl = 'updateTask'
        //                     element.removeUrl = 'removeTask'
        //                     element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
        //                     element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' }
        //                     element.fields = this.state.headers
        //                     frames.push(element)
        //                 }
        //             }
        //         });
        //     }
        //     frames = [...frames, ...Object.values(DeskFrames.pages)]
        //     let headerConfig = this.state.headerConfig
        //     headerConfig.frames = this.state.frames
        //     this.setState({ headerConfig, frames })
        // }
    }
    functionsHandler = (type, name, data, extra) => {
        console.log('vfunctionsHandler')
        if (this[name]) {
            this[name](data, extra)
        }
    }
    checkDefaultTab() {

        checkDefaultTab(this.props.windowData, this.props.baseUrl, this.state.frames, this.props.width, (pageInfo, pageType, def) => {
            // console.log('checkDefaultTabcb', pageType)
            def = def ?? ''
            pageType = pageType != null ? pageType : def
            // console.log('pageTypepp', pageType)
            if (pageType != null) {
                this.setState({ oldData: this.props.windowData, path: def, pageType: pageType }, () => {
                    setTimeout(() => {
                        this.setState({ page: pageInfo, pageType, headers: pageInfo?.fields ?? pageInfo?.headers, pageStatus: 200 }, () => {
                            let variables = this.state.variables
                            if (pageInfo && pageInfo._id) {
                                variables.frameId = pageInfo._id
                                // console.log('this.props.userSettingsonAdmin', this.props.userSettings)
                                this.filterUserSettings()
                            }

                            console.log("pageType", pageType)
                            this.setState({ variables })
                            let frames = this.state.frames
                            let page
                            frames.map((item) => {
                                if (item._id == pageType) {
                                    page = item
                                }
                            })
                            if (page) {
                                this.setState({ page }, () => {

                                    if (this.stageManager && pageType) {
                                        this.stageManager.changeStage(('collection'), () => {
                                        })
                                    } else {
                                        this.stageManager.changeStage((''))
                                    }
                                })
                            }
                        })
                    }, 10);
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        })
    }


    // checkDefaultTab() {
    //     let def = ''
    //     let pageType = null
    //     let pathname = this.props.windowData.path//window.location.pathname.split('/')
    //     let rootRef = this.props.route.split('/')
    //     rootRef = rootRef[rootRef.length - 1]
    //     let pageIsValid = false
    //     if (rootRef.includes('admin') || pathname.includes('admin')) {
    //         def = 'admin'
    //         pageType = 'admin'
    //         pageIsValid = true
    //     }
    //     if (!def) {
    //         def = ''
    //     }
    //     if (def === '') {
    //         pageType = ''
    //         pageIsValid = true
    //     }
    //     if (pageIsValid) {
    //         this.setState({ oldData: this.props.windowData }, () => {
    //             this.setState({ path: def, pageType }, () => {
    //                 setTimeout(() => {
    //                     this.setState({ page: null }, () => {
    //                         this.setState({ pageType, pageStatus: 200 }, () => {
    //                             if (this.stageManager) {
    //                                 this.stageManager.changeStage((pageType), () => {
    //                                 })
    //                             } else { }
    //                         })
    //                     })
    //                 }, 10);
    //             })
    //         })
    //     } else {
    //         this.setState({ pageStatus: 404 })
    //     }
    // }

    setData = (key, value, reference, cb) => {
        if (reference == 'CommerceApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    updateFrames = (info) => {
        let frames = this.state.frames
        info.forEach(mframe => {
            let element = mframe
            if (element) {
                if (mframe?.type == 'page') {
                    element.key = element._id
                    element.section = 'pages'
                    element.pageType = 'page'
                    element.fetchUrl = 'getRecords'
                    element.addUrl = 'postRecord'
                    element.editUrl = 'postRecord'
                    element.removeUrl = 'removeRecord'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.fields = this.state.headers
                    frames.push(element)
                }
                else if (mframe?.type == 'recordClassifier') {
                    element.key = element._id
                    element.section = 'pages'
                    element.pageType = 'classifier'
                    element.fetchUrl = 'getMyTasks'
                    element.addUrl = 'postRecord'
                    element.editUrl = 'postRecord'
                    element.removeUrl = 'removeRecord'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                    element.fields.forEach(field => {
                        field.key = field.key
                    });
                    frames.push(element)
                }
                else {
                    element.key = element._id
                    element.section = 'collections'
                    element.pageType = 'collection'
                    element.fetchUrl = 'getMyTasks'
                    element.addUrl = 'addTask'
                    element.editUrl = 'updateTask'
                    element.removeUrl = 'removeTask'
                    element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{frameId}}' }
                    element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' }
                    element.fields = this.state.headers
                    frames.push(element)
                }
            }
        });
        console.log('framesssssffflff', frames)
        this.setState({ frames })
    }
    changePage = (page, info) => {
        // console.log('*changePage')
        let extraPath = Array.isArray(page) ? page : [page]
        let fullPath = [...this.props.baseUrl, ...extraPath]
        this.changeWindow(fullPath, info)
    }
    changeWindow = (list, info) => {
        if (Array.isArray(list)) {
            let finalList = []
            list.forEach(value => {
                let one = value
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
                if (one) {
                    finalList.push(one)
                }
            });
            let data = { type: 'applet', path: finalList }
            if (info) {
                data.info = info
            }
            this.props.changeWindow('applet', data)
        }
    }
    setCurrentApplet = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }

    render() {
        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') { }
        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }
        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }
        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false
        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        return (
            <div className=' bg-white w-100 d-flex flex-column window-content-radius h-100' >
                {/* <PageStatusViewer status={this.state.pageStatus} isLoading={this.state.isLoading} applet={this.props.applet} colors={colors} addNewWindow={this.props.addNewWindow}> */}
                <div style={{ position: 'relative', top: 0 }}>
                    <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} />
                </div>
                <StagesManager ref={el => this.stageManager = el} height={'0px'} className={'flex-1'} fast={true}  >
                    <PageViewer stage={0} userView={this.props.userView} stageName={''} baseUrl={this.props.baseUrl} page={this.state.mainPage}
                        variables={this.props.variables} colors={this.props.colors} frames={this.state.frames}
                        framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink}
                        width={this.props.width} functionsHandler={this.functionsHandler} height={this.props.height}
                        setHeader={this.setHeader} windowData={this.props.windowData} route={this.props.rootUrl}
                        applet={this.props.applet} connection={this.props.connection} user={this.props.user}
                        setUser={this.props.setUser} addNotif={this.props.addNotif} history={this.props.history}
                        location={this.props.location} goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} />

                    <CollectionView stageName={'collection'} permissionLevel={this.props.permissionLevel} isMobile={this.props.isMobile} permissions={this.props.permissions} changeWindow={this.changeWindow} changePage={this.changePage} updateFrameInfo={this.updateFrameInfo} ref={el => this.collectionView = el} setData={this.setData} setHeader={this.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} modules={this.state.modules} formPages={this.state.page?.formPages} page={this.state.page} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} applet={this.props.applet} headers={this.state.headers} automations={this.props.automations} language={this.props.language} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} goToHub={this.props.goToHub} variables={this.state.variables} functionsHandler={this.functionsHandler} appletAccess={this.props.appletAccess} updateUserSettings={this.props.updateUserSettings} />



                    {/* <div stage={0} stageName=''>test1</div> */}
                </StagesManager>
                {/* </PageStatusViewer> */}
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeskApplet);